import { IProps } from "./numeric-value.types";
import { NEGATIVE_ZERO_PATTERN } from "./numeric-value.constants";
import { Text } from "../text";

/**
 * Display a numeric value with optional rounding.
 * @param props.value The value to display.
 * @returns           Value.
 */
const NumericValue = ({ options, unit, value, ...textProps }: IProps) => {
    if (typeof value !== "number" || isNaN(value)) {
        return "--";
    }

    // Perform any necessary rounding but don't allow negative zero values like "-0".
    const formatted = options ? value.toLocaleString(undefined, options) : value.toLocaleString();
    const finalNumber = NEGATIVE_ZERO_PATTERN.test(formatted) ? formatted.replace(/^-/, "") : formatted;

    return (
        <>
            {finalNumber}
            {typeof unit !== "undefined" && unit}
        </>
    );
};

const NumericValueSkeleton = Text.Skeleton;
NumericValue.Skeleton = NumericValueSkeleton;

export { NumericValue, NumericValueSkeleton };
